/* eslint-disable */
/**
 * The path of the `LogoutPage` to be consumed by a `<Router />`
 * @export
 */
export const LOGOUT_PAGE_PATH = `/logout`;

/**
 * Create a `href` that will resolve to `LogoutPage`
 * @export
 * @returns {string} The `LOGOUT_PAGE_PATH`
 */
export const createLogoutPageLink = () => LOGOUT_PAGE_PATH;

/**
 * Determine if the current page is the `Logoutpage`
 * @export
 * @param {RouterMatch<any>} match The `react-router-dom`'s `match` params
 * @returns {boolean} Whether or not the current page is `Logoutpage`
 */
export const isLogoutpage = (match) => match.path === LOGOUT_PAGE_PATH;
